import { render } from "./RedefinirSenha.vue?vue&type=template&id=6deb08de&scoped=true"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js"

import "./RedefinirSenha.vue?vue&type=style&index=0&id=6deb08de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deb08de"]])

export default __exports__